import { useEffect } from 'react';

import { wxCopilotContextManager } from 'utils/wxCopilotContextManager';

export function useWxCopilotWorkflowContext({
  workflowId,
  workflowName,
  currentStageId,
  currentStageName,
}) {
  useEffect(() => {
    if (workflowId && workflowName) {
      wxCopilotContextManager.setWorkflowContext({
        workflowId,
        workflowName,
        currentStageId,
        currentStageName,
      });
    }

    return () => {
      wxCopilotContextManager.setWorkflowContext(undefined);
    };
  }, [workflowId, workflowName, currentStageId, currentStageName]);
}
